import type { SavingEnvelopesCountryConfig } from './SavingEnvelopesConfig';

export const savingEnvelopes: SavingEnvelopesCountryConfig = {
    maxEnvelopeLimit: 9,
    showEnvelopeNumberInfo: true,
    filterUserEnvelopesOnFrontend: true,
    amountInputMaxLength: 10,
    envelopeNameErrorTranslationKey:
        'saving:savingEnvelopes.errors.CZ-FIELD_CHARACTER_NOT_PERMITTED',
};
